import { FieldValues, UseFormReturn } from 'react-hook-form';

import { isEmpty } from 'lodash';

export function useFormDebug(methods: UseFormReturn<FieldValues, any, FieldValues>) {
    if (!isEmpty(methods.formState.errors)) {
        // eslint-disable-next-line no-console
        console.warn('Form has errors :', methods.formState.errors, methods.getValues());
    }
}
